/*
 * - SABBANG PAHAYA GAMANEEYAN -
 * Created on Mon Jan 30 2023 5:00:25 AM
 *
 * By Kapila Rathnayaka
 *
 * Copyright (c) 2023 Kayble Zone Private Limited - Colombo Sri Lanka
 * Contact : http://www.kayblezone.lk - kapilarathnayaka@outlook.com
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "./BreadCrumb";
import globalSearch from "../images/globalSearch.png";
import { RxHamburgerMenu } from "react-icons/rx";
import { useBreadCrumb } from "../../context/BreadCrumbContext";

const menuItems = [
  { label: "Home", link: "/", className: "home" },
  { label: "Publications", link: "/publications", className: "biblio" },
  { label: "Blogs", link: "/blogs", className: "blogs" },
  { label: "Projects", link: "/projects", className: "projects" },
  {
    label: "Research Briefings",
    link: "/research-briefings",
    className: "researchBriefing",
  },
  { label: "Resources", link: "/resources", className: "resources" },
  {
    label: "Fire Australia",
    link: "/fireaustralia",
    className: "fireaustralia",
  },
, {
    label: "Organisations",
    link: "/organisations",
    className: "fireaustralia",
  },
];

const Header = () => {
  const { breadCrumbLinks, setBreadCrumbLinks } = useBreadCrumb();
  const [displayGlobalSearch, setDisplayGlobalSearch] = useState(false);
  const [navLink, setNavLinks] = useState("/");
  if (
    window.location.pathname == "/results" ||
    window.location.pathname.indexOf("/blogs") == 0 ||
    window.location.pathname.indexOf("/resources") == 0 ||
    window.location.pathname.indexOf("/projects") == 0 ||
    window.location.pathname.indexOf("/research-briefings") == 0 ||
    window.location.pathname.indexOf("/publications") == 0 ||
    window.location.pathname.indexOf("/fireaustralia") == 0
  ) {
  }

  const changeLinksRoutes = (route) => {
    setNavLinks(route);
    setIsOpen(false);
  };

  useEffect(() => {
    if (
      window.location.pathname == "/" ||
      window.location.pathname == "/results"
    ) {
      setDisplayGlobalSearch(false);
    } else {
      setDisplayGlobalSearch(true);
    }
  }, [window.location.pathname]);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {/* Hamburger Icon */}
      <div className=" flex fixed top-2  z-10 md:top-6   ">
        <div
          onClick={() => setIsOpen(true)}
          className="bg-white h-[44px] w-[80px] shadow-lg pl-4 pr-4 hover:cursor-pointer rounded-full rounded-tl-none rounded-bl-none"
        >
          <RxHamburgerMenu fontSize="30px" style={{ margin: "7px auto" }} />
        </div>
        <div className=" flex items-center ml-8">
          <BreadCrumb />
        </div>
      </div>
      {/* Sidebar Menue */}
      <main
        className={
          " fixed z-10  bg-opacity-25 inset-0 transform ease-in-out " +
          (isOpen
            ? "transition-transform duration-500 translate-x-0"
            : "transition-transform duration-1000 -translate-x-full")
        }
      >
        <section
          className={
            "absolute  w-full max-w-[250px] left-0 bg-white h-full shadow-2xl  duration-300 ease-in-out transition-transform transform " +
            (isOpen ? "translate-x-0" : "-translate-x-full")
          }
        >
          <div
            className="absolute top-8 -right-[68.2px] bg-white shadow-lg pl-6 py-1 pr-3 hover:cursor-pointer rounded-full rounded-tl-none rounded-bl-none"
            onClick={() => setIsOpen(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-8 h-8"
              onClick={() => setIsOpen(!isOpen)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div className="flex flex-col w-full max-w-[75%] mx-auto mt-8">
            <Link
              onClick={() => {
                setBreadCrumbLinks([
                  { name: "Home", link: "/" },
                  { name: "Global", link: "/results" },
                ]);
                setIsOpen(false);
              }}
              to="/results"
              className="flex flex-col justify-center w-full h-11 pl-5 border font-semibold text-blackish_grey hover:!text-blackish_grey  border-gray-300 text-base"
            >
              Site search
            </Link>

            <div className="mt-6">
              <p className="font-medium text-blackish_grey text-base mb-2">
                Or Navigate to:
              </p>
              {menuItems.map((item, index, c) => (
                <a
                  href={item.link}
                  onClick={() => changeLinksRoutes(item.link)}
                  className={`group-hover border-left link-fill-border relative flex flex-col justify-center w-full h-11 pl-5 border-l border-t border-r last:border-b font-normal text-blackish_grey border-gray-300 group ${item.className}`}
                  key={index}
                >
                  <span>{item.label}</span>
                  <span className="absolute top-0 left-0 w-0 group-hover:w-full h-full bg-yellow-300"></span>
                </a>
              ))}
            </div>
            <div className="mt-4">
              <p className="  font-semibold text-blackish_grey text-sm">
                Using the site:
              </p>
              <p className="font-light text-blackish_grey text-sm mt-2">
                The best way to navigate this site is through the Site search
                bar. Enter a search term and further narrow down your results by
                content type using the search filters.
              </p>
            </div>
          </div>
        </section>
        <section
          className="w-screen h-full cursor-pointer"
          onClick={() => {
            setIsOpen(false);
          }}
        ></section>
      </main>
      {displayGlobalSearch ? (
        <div className="hidden md:flex fixed top-6 right-0 z-10 gap-2 mr-20 tracking-normal items-center">
          <Link
            onClick={() => {
              setBreadCrumbLinks([
                { name: "Home", link: "/" },
                { name: "Site Search", link: "/results" },
              ]);
              setIsOpen(false);
            }}
            to="/results"
          >
            {" "}
            <p className="text-white">Site search</p>
          </Link>
          <Link
            onClick={() => {
              setBreadCrumbLinks([
                { name: "Home", link: "/" },
                { name: "Site Search", link: "/results" },
              ]);
              setIsOpen(false);
            }}
            to="/results"
          >
            {" "}
            <img src={globalSearch} alt="Not found" />
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default Header;
